import type { AnalyticsEventMap, AnalyticsEventName } from "./events";
import { captureAnalyticsEvent } from "./use-analytics";

function capture<TName extends AnalyticsEventName>(
  eventName: TName,
  properties: AnalyticsEventMap[TName]
) {
  captureAnalyticsEvent(eventName, properties);
}

export const trackNavigationEvent = capture;
export const trackClaudiaEvent = capture;
export const trackQualityGuardEvent = capture;
export const trackVersionEvent = capture;
export const trackVoiceEvent = capture;
export const trackEntityEvent = capture;
export const trackClarificationEvent = capture;
